import {
  Box,
  Grid,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import componentStyles from "../assets/styles/components/issue_list";

const useStyles = makeStyles(componentStyles);
const SearchList = memo((props) => {
  const { results = [] } = props;
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  const handleClickListItem = async (issue) => {
    history.push({
      pathname: "/issue/" + issue.id,
    });
  };

  return (
    <>
      <List>
        {results.map((issue, index) => {
          return (
            <ListItem
              className={classes.listItem}
              alignItems="flex-start"
              key={index}
              button
              onClick={(e) => handleClickListItem(issue)}
            >
              <Grid item xs>
                <ListItemText
                  primary={
                    <>
                      <Typography className={classes.issueTitle}>
                        {issue.title}
                      </Typography>
                    </>
                  }
                  secondary={
                    <>
                      <Box className={classes.issueParams}>
                        <Box className={classes.issueParam}>
                          <Box className={classes.issueParamValue}>
                            {issue.description &&
                              issue.description.slice(0, 200)}
                          </Box>
                        </Box>
                      </Box>
                    </>
                  }
                />
              </Grid>
            </ListItem>
          );
        })}
      </List>
    </>
  );
});

export default SearchList;
